import { Card, Button } from '../design-system/components';

/**
 * Verification card component - Assignr-style display
 * Used in verify mode for quick confirmation
 */
export const VerificationCard = ({
  request,
  isSelected,
  onSelect,
  onConfirm
}) => {
  return (
    <Card
      onClick={onSelect}
      accent={isSelected ? 'var(--success)' : 'var(--border-strong)'}
      padding="var(--space-3)"
      style={{
        boxShadow: isSelected ? '0 0 0 3px var(--ink), var(--shadow-sm)' : 'var(--shadow-sm)',
        cursor: 'pointer',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
      }}
    >
      <div className="flex justify-between items-start mb-1">
        <div style={{ fontWeight: 'var(--fw-bold)', color: 'var(--text-strong)' }}>
          <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--folk-green-deep)' }}>{request['Date'] || request['Requested Date']}</span>
          <span className="ml-2" style={{ fontFamily: 'var(--font-mono)', color: 'var(--text-body)' }}>{request['Time'] || request['Preferred Time']}</span>
          <span className="ml-2" style={{ fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
            @ {request['Venue'] || request['Requested Venue']}
            {request['Sub Venue'] && ` ${request['Sub Venue']}`}
          </span>
        </div>
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', textAlign: 'right' }}>
          Requested: {request['Requested Date']}<br/>at {request['Preferred Time']}
        </div>
      </div>

      <div className="mb-1" style={{ fontWeight: 'var(--fw-bold)', color: 'var(--text-strong)' }}>
        {request['Age Group']}: {request['Home Team']} vs {request['Away Team']}
      </div>

      <div className="flex justify-between items-center mt-2">
        <div className="flex gap-2 items-center" style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
          {request['Game Number'] && (
            <span style={{ fontFamily: 'var(--font-mono)', background: 'var(--ink)', color: 'var(--text-inverse)', padding: '4px 8px', fontWeight: 'var(--fw-bold)', borderRadius: 'var(--radius-sm)' }}>
              #{request['Game Number']}
            </span>
          )}
          {request['Game Type'] && <span>&bull; {request['Game Type']}</span>}
          {request['Contact Name'] && <span>&bull; {request['Contact Name']}</span>}
        </div>
        <Button
          variant="primary"
          size="sm"
          iconLeft="check"
          onClick={(e) => {
            e.stopPropagation();
            onConfirm(request);
          }}
        >
          Confirm & Schedule
        </Button>
      </div>
    </Card>
  );
};
